/**
 * 将历史单文件字段和新附件数组统一为页面可用的附件对象。
 *
 * @param {Object|string} attachment 后端返回的附件对象或历史文件名
 * @returns {Object|null} 包含存储文件名与展示文件名的附件对象
 */
export function normalizeReportAttachment (attachment) {
  if (!attachment) {
    return null
  }

  if (typeof attachment === 'string') {
    return {
      storedName: attachment,
      originalName: attachment
    }
  }

  const storedName = attachment.storedName || attachment.picName
  if (!storedName) {
    return null
  }

  return {
    storedName,
    originalName: attachment.originalName || storedName,
    storageMonth: attachment.storageMonth || ''
  }
}

/**
 * 解析报告单附件字段，兼容历史单文件字符串和新 JSON 数组。
 *
 * @param {string} value 报告单 FUJIAN_ADDR 字段值
 * @returns {Array<Object>} 附件列表
 */
export function parseReportAttachments (value) {
  if (!value) {
    return []
  }

  let parsedValue = null
  try {
    parsedValue = JSON.parse(value)
  } catch (e) {
    parsedValue = null
  }

  const attachments = Array.isArray(parsedValue) ? parsedValue : [value]
  const seen = {}
  return attachments.map(normalizeReportAttachment).filter(attachment => {
    if (!attachment || seen[attachment.storedName]) {
      return false
    }
    seen[attachment.storedName] = true
    return true
  })
}

/**
 * 将附件列表转换为后端持久化的 JSON 字符串。
 *
 * @param {Array<Object>} attachments 当前报告单保留的附件列表
 * @returns {string} 可存储到 FUJIAN_ADDR 的 JSON 字符串
 */
export function stringifyReportAttachments (attachments) {
  return JSON.stringify(parseReportAttachments(JSON.stringify(attachments || [])))
}

/**
 * 构建单个报告单附件的下载地址。
 *
 * @param {string|number} reportId 报告单主键
 * @param {string} storedName 服务器存储文件名
 * @param {string} token 下载令牌
 * @returns {string} 下载地址
 */
export function createReportAttachmentDownloadUrl (reportId, storedName, token) {
  return '/api/CusFahuo/downloadFahuo?fileName='
    + encodeURIComponent(storedName)
    + '&id=' + encodeURIComponent(reportId)
    + '&token=' + encodeURIComponent(token || '')
}
